import Cookies from "js-cookie";

export const fetchAuthToken = ({
  user: { registeredUser, unverifiedUser },
  anonymousUser
}: any) => {
  const cookieToken: string = Cookies.get("unexpected_thunder");

  if (registeredUser?.isLoggedIn) {
    if (process.env.NODE_ENV === "development") {
      return {
        token: cookieToken
      };
    }
    return {
      token: null
    };
  }
  return {
    token: unverifiedUser?.token || anonymousUser?.token
  };
};
